/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-20 18:35:05
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-21 21:36:12
 * @FilePath: /mooctest.com/src/utils/utils.js
 */
export function openLink(link, target = "_blank") {
  window.open(link, target);
}
export function timeFormat(time) {
  const dateString = new Date(time);
  // 注意js里面的getMonth是从0开始的
  const FormattedDateTime = `${dateString.getFullYear()}-${
    dateString.getMonth() + 1
  }-${dateString.getDate()} ${dateString.getHours()}:${dateString.getMinutes()}:${dateString.getSeconds()}`;
  return FormattedDateTime;
}
